<template>
  <div>
    <div class="appointment-table table-common">
      <el-table :data="allAppointData" style="width: 100%">
        <el-table-column type="index" label="序号" width="82">
        </el-table-column>
        <el-table-column label="预约详情" width="880">
          <template slot-scope="scope">
            <ul>
              <li>
                <p>预约流水号</p>
                <p>{{scope.row.code}}</p>
              </li>
              <li>
                <p>预约时段</p>
                <p>{{scope.row.beginTime}}-{{scope.row.endTime}}</p>
              </li>
              <li>
                <p>预约日期</p>
                <p>{{scope.row.date}}</p>
              </li>
              <li>
                <p>业务名称</p>
                <p>{{scope.row.busName}}</p>
              </li>
              <li>
                <p>事项名称</p>
                <p>{{scope.row.itemName ? scope.row.itemName : '-'}}</p>
              </li>
              <li>
                <p>批量件</p>
                <p>{{+scope.row.handleNum > 1 ? '是' : '否'}}</p>
              </li>
              <li>
                <p>预约来源</p>
                <p>{{scope.row.reserveSrcName || '-'}}</p>
              </li>
            </ul>
            <ul>
              <li>
                <p>姓名</p>
                <p>{{sensitiveField(scope.row.name)}}</p>
              </li>
              <li>
                <p>手机号</p>
                <p>{{sensitiveField(scope.row.phone)}}</p>
              </li>
              <li>
                <p>身份证</p>
                <p>{{sensitiveField(scope.row.cardNum)}}</p>
              </li>
              <li>
                <p>企业名称</p>
                <p>{{scope.row.eprName ? scope.row.eprName : '-'}}</p>
              </li>
              <li>
                <p>办理件数</p>
                <p>{{scope.row.handleNum || 1}}</p>
              </li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column label="预约状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">预约待办</span>
            <span v-else-if="scope.row.status == 1">已取消</span>
            <span v-else-if="scope.row.status == 2">已过期</span>
            <span v-else>预约已办</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <a href="javascript:void(0)" v-if="scope.row.showChange == 0 && scope.row.allowChange == 0 && scope.row.status == 0" class="cancel" @click="openAppointment(scope.row)">预约改期</a>
            <a href="javascript:void(0)" v-if="scope.row.status == 0" class="cancel" @click="handleAppoint(0,scope.row.seq)">取消预约</a>
            <a href="javascript:void(0)" v-if="scope.row.status != 0 " @click="handleAppoint(1,scope.row.seq)">删除预约</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <p class="total-items">共{{pageObj.totalRow}}条数据</p>
    <div class="page-content">
      <el-pagination background @current-change="changePage" :current-page="pageObj.currPage" :page-size.sync="pageObj.pageRowNum" layout="prev, pager, next" :total="pageObj.totalRow" ref="pager">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import { sensitiveField } from '@/utils/sensitiveUtil.js'
export default {
  name: "allAppointmentTable",
  props: {
    allAppointData: {
      type: Array
    },
    pageObj: {
      type: Object
    }
  },
  data() {
    return {};
  },
  filters: {},
  mounted() {
    // console.log('allAppointData', this.allAppointData);
  },
  methods: {
    // 脱敏方法，与minixs引入效果一样
    sensitiveField,
    handleAppoint(type, seq) {
      // 删除预约
      if (type == 1) {
        MessageBox.confirm("预约办件将永久删除，是否确认删除？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$emit("delAppointment", seq);
        }).catch(() => {
          Message({
            type: "info",
            message: "已取消删除"
          });
        });
      } else {
        // 取消预约
        MessageBox.confirm("取消预约办件，是否确认取消？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$emit("cancleAppointment", seq);
        }).catch(() => {
          // Message({
          //   type: "info",
          //   message: "已取消"
          // });
        });
      }
    },
    // 预约改期
    openAppointment(val) {
      this.$emit("openAppointment", val);
    },
    //分页
    changePage(val) {
      //  this.$emit("changeAppointment", val);
      this.$emit("changePage", val);
    }
  }
};
</script>
<style lang="scss">
.appointment-table {
  margin-top: 26px;

  thead tr th {
    &:first-of-type {
      padding-left: 10px;
    }

    &:nth-of-type(4) {
      text-align: right;
      padding-right: 20px;
    }
  }

  tbody tr td {
    &:nth-of-type(1) {
      padding-left: 10px;
    }

    &:nth-of-type(2) {
      ul {
        width: 394px;
        &:first-of-type {
          float: left;
          margin-right: 30px;
        }

        &:last-of-type {
          float: left;
        }
      }

      p {
        font-family: "PingFangSC-Regular";
        font-size: 16px;
        color: #333333;
        margin-bottom: 8px;
        &:first-of-type {
          float: left;
          width: 85px;    
          color: #727475;
          padding-right: 8px;
        }

        &:last-of-type {
          float: left;
          width: 240px;
        }
      }
    }

    &:last-of-type {
      .cell a {
        &.cancel {
          color: #ffffff;
          background: $main-color;
          margin: 5px 0;
        }
      }
    }
  }
}

.total-items {
  text-align: right;
  margin: 20px 0 90px 0;
  font-family: "PingFangSC-Regular";
  font-size: 16px;
  color: #999999;
  text-align: right;
}

.page-content {
  text-align: right;
}

.table-common {
  border-radius: 4px;
  border: 1px solid #dddddd;
  border-bottom: none;
  thead tr th {
    background-color: #f9f9f9;
    font-family: "PingFangSC-Medium";
    font-size: 18px;  
    color: #45484B;
    font-weight: 500;
    line-height: 27px;
    &.el-table__cell{
      background: #F9F9F9;
    }
  }

  tbody tr td {
    font-size: 16px;
    &:last-of-type .cell {
      a {
        cursor: pointer;
        display: inline-block;
        width: 86px;
        height: 30px;
        line-height: 30px;
        background: #ffffff;
        border: 1px solid $main-color;
        border-radius: 3px;
        text-align: center;
        font-size: 16px;
        color: $main-color;
        padding: none;
      }
    }
  }

}
</style>